import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';

import {
  OptionalFeatureBase,
  FeatureBase
} from "@models";
import { 
  Character,
  CharacterFeatureSource,
} from "@dndModels";

import CommonUtilities from "@utilities/common_utilities";

import CheckBox from "@components/input/CheckBox";
import LoadingBox from "@components/input/LoadingBox";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";

interface Props {
  character: Character;
  char_feature_source: CharacterFeatureSource;
  optional_feature_bases?: OptionalFeatureBase[];
  feature_bases?: FeatureBase[];
  onChange: (_id: string, value: boolean) => void;
}
const common_util = CommonUtilities.getInstance();

export default function CharacterFeatureBaseOptionsInput({
  character,
  char_feature_source,
  optional_feature_bases = [],
  // feature_bases = [],
  onChange
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [optional_feature_base_ids, setOptionalFBIDs] = useState<string[]>([]);

  // eslint-disable-next-line
  useEffect(() => {
    if (!fetched) {
      setOptionalFBIDs(character.optional_feature_base_ids);
      setFetched(true);
    }
  });
  
  if (!fetched) {
    return (<LoadingBox />);
  } else {
    // debugger;
    let use_ofbs = [...optional_feature_bases];
    if (use_ofbs.length > 0) {

      const renderOfbsForSource = (cfs: CharacterFeatureSource) => {
        const cfs_ofbs = use_ofbs.filter(o => o.feature_source_id === cfs.source_id);
        const levels = common_util.unique_array(cfs_ofbs.map(o => o.level)).sort();
        return (
          <Grid
            key={cfs.true_id}
            container
            spacing={0}
            direction="row"
            size={{
              xs: 12
            }}>
            <Grid
              className="header"
              size={{
                xs: 12
              }}>{cfs.source?.name??""}</Grid>
            { levels.map(level => {
              return (
                <Grid
                  key={level}
                  size={{
                    xs: 12
                  }}>
                  <Grid container spacing={0} direction="row">
                    <Grid
                      className="gray"
                      size={{
                        xs: 12
                      }}>Level { level }</Grid>
                    { cfs_ofbs.filter(o => o.level === level).map(fb => {
                      return (
                        <Grid
                          key={fb._id}
                          size={{
                            xs: 12
                          }}>
                          <div 
                            style={{
                              padding: "4px"
                            }} 
                          >
                            <Grid container spacing={0} direction="row">
                              <Grid
                                size={{
                                  xs: 12
                                }}>
                                <CheckBox
                                  name={ fb.name }
                                  value={optional_feature_base_ids.includes(fb._id)} 
                                  onChange={(changed: boolean) => {
                                    let new_ids = [...optional_feature_base_ids];
                                    if (changed) {
                                      new_ids.push(fb._id);
                                    } else {
                                      new_ids = new_ids.filter(o => o !== fb._id);
                                    }
                                    setOptionalFBIDs(new_ids);
                                    setTimeout(() => {
                                      onChange(fb._id, changed);
                                    }, 500);
                                  }}
                                />
                              </Grid>
                              { fb.description.length > 0 &&
                                <Grid
                                  size={{
                                    xs: 12
                                  }}>
                                  <DisplayStringWithReplacements display_string={ fb.description } />
                                </Grid>
                              }
                            </Grid>
                          </div>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
        );
      }

      use_ofbs = use_ofbs.filter(o => 
        common_util.anyOverlaps(["",...character.character_options.source_books], o.source_book_ids));
      const source_ids = common_util.unique_array(use_ofbs.map(o => o.feature_source_id));
      const sources: CharacterFeatureSource[] = []; 
      if (source_ids.includes(char_feature_source.source_id)) {
        sources.push(char_feature_source);
      }
      sources.push(...char_feature_source.sub_char_feature_sources.filter(o => source_ids.includes(o.source_id)));
      
      return (
        <>
          { sources.map(cfs => renderOfbsForSource(cfs)) }
        </>
      );
    }
  }
  return <></>;
}
